module.exports = __webpack_public_path__ + "static/image3-465ffc345597155ed1329c48f88a60d9.jpg";